module.exports = __webpack_public_path__ + "img/article.ceb5521b.png";